module.exports = __webpack_public_path__ + "static/media/logo-green.59b29dcf.svg";